'use strict';

var React = require('react'),
    invariant = require('react/lib/invariant'),
    AnalyticsSources = require('../constants/AnalyticsSources'),
    { values } = require('underscore');

function createAnalyticsContextMixin(source) {
  invariant(typeof source === 'string', 'Expected a source.');

  return {
    childContextTypes: {
      source: React.PropTypes.oneOf(values(AnalyticsSources)).isRequired
    },

    getChildContext() {
      return {
        source: source
      };
    }
  };
}

module.exports = createAnalyticsContextMixin;


/** WEBPACK FOOTER **
 ** ./mixins/createAnalyticsContextMixin.js
 **/